<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content" type="primary">
        <div style="height: auto;width: 150%;margin-top: 5px;" class="cargo-advance-search">
          <div class="section cargo-advance-search-more">
            <el-form
              label-position="left"
              label-width="150px"
              style="min-width: 830px;margin-right: 10px;"
              :inline="true"
            >
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item :label="$t('SeaExport.ImportTime')">
                    <el-date-picker v-model="filter.pushTimeStar" no="1" style="width:120px;" type="date" value-format="yyyy-MM-dd" />&nbsp;{{ $t('SeaExport.To') }}
                    <el-date-picker v-model="filter.pushTimeEnd" no="2" style="width:120px;" type="date" value-format="yyyy-MM-dd" />
                  </el-form-item>
                  <el-form-item :label="$t('Message.ImportResults')">
                    <el-select v-model="filter.importResult" no="3" style="width:150px;">
                      <el-option
                        v-for="(item,index) in filter.importResultList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_ShowRows')">
                    <el-input-number v-model="filter.maxResult" no="4" controls-position="right" :min="10" :max="500" :precision="0" @change="saveMaxResult" />
                  </el-form-item>
                  <el-form-item label-width="0">
                    <el-button type="primary" no="5" @click="queryHandler"> {{ $t('CargoMsg.Cargo_Query') }} </el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item :label="$t('SeaExport.BusinessType')">
                    <el-select v-model="filter.businessType" no="6" style="width:262px;" @change="bussinessType_changeHandler">
                      <el-option
                        v-for="(item,index) in filter.businessTypeList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.noRule')">
                    <el-select v-model="filter.noRule" no="7" style="width:150px;">
                      <el-option
                        v-for="(item,index) in filter.noRuleList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item :label="$t('SeaExport.Account2')">
                    <cargo-advance-select
                      no="8"
                      :select-type="selectTypeNames.basic_data_Company"
                      :data-filter-function="tiAccountFilter"
                      filterable
                      style="width: 262px;"
                      :default-value="filter.tiAccount||''"
                      @parentCallBack="tiAccount_changeHandler"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.Oversea')">
                    <el-radio-group v-model="filter.overSeaType" no="9">
                      <el-radio :label="0">{{ $t('SeaExport.internal') }}</el-radio>
                      <el-radio :label="1">{{ $t('SeaExport.overseas') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item :label="$t('SeaExport.ReceivableType')">
                    <el-radio-group v-model="filter.accountType" no="10">
                      <el-radio :label="1">{{ $t('SeaExport.receivable') }}</el-radio>
                      <el-radio :label="0">{{ $t('SeaExport.payable') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="20150100"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>this.gridApi=params.api"
          />
        </div>
      </div>
    </div>
  </div></template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { queryImportFileRecordLog } from '@/api/clearing/charge'
import { DocumentManage } from '@/utils/commonUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import LocalStorageUtils from '@/utils/localStorageUtils'
import URL from '@/api/urlTranslator'

export default {
  name: 'ImportRecordSearch',
  components: { CargoAdvanceSelect },
  props: {
    lob: { type: String, required: true } // 业务类型
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      SystemConstants,
      selectTypeNames: TYPE_NAMES,
      showDetail: false,
      gridParams: {},
      rowData: [],
      gridApi: null,
      documentManage: new DocumentManage(),
      filter: {
        maxResult: 20,
        overSeaType: 0, // 国内国外, 默认国内
        tiAccount: 0, // 结算单位
        accountType: 1, // 收付类型 默认 应收
        pushTimeStar: '', // 导入时间
        pushTimeEnd: '', // 导入时间
        importResult: 1, // 导入结果
        importResultList: [],
        businessType: 'SE',
        businessTypeList: [],
        noRuleList: [],
        noRule: ''
      },
      gridOptions: {
        rowSelection: 'single'
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.SerialNo'), field: 'IMPORT_NO', colId: 'IMPORT_NO', width: 200,
          valueFormatter: (params) => {
            return params.value.toString()
          }
        },
        {
          headerName: this.$t('SeaExport.ImportTime'), field: 'DATE_CREATED', colId: 'DATE_CREATED', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'), field: 'CREATED_BY', colId: 'CREATED_BY', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.BusinessType'), field: 'LOB', colId: 'LOB', width: 150,
          valueFormatter: (params) => {
            return this.getBusinessTypeFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.noRule'), field: 'NO_RULE', colId: 'NO_RULE', width: 150,
          valueFormatter: (params) => {
            return this.getNoRuleFunc(params.data, params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ReceivableType'), field: 'ACCOUNT_RECEIVABLE', colId: 'ACCOUNT_RECEIVABLE', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Account2'), field: 'ACCOUNT_ID', colId: 'ACCOUNT_ID', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.importFile'), field: 'IMPORT_FILE_ID', colId: 'IMPORT_FILE_ID', width: 150, noExport: true,
          cellRenderer: (params) => {
            const methodOnFileViewPath = this.documentManage.getPath('onFileView')
            return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:blue;text-decoration: underline;">${this.$t('FileHistory.view')}</a>`
          }
        },
        {
          headerName: this.$t('SeaExport.logFile'), field: 'RESULT_FILE_ID', colId: 'RESULT_FILE_ID', width: 150, noExport: true,
          cellRenderer: (params) => {
            const methodOnFileViewPath = this.documentManage.getPath('onFileView')
            return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:blue;text-decoration: underline;">${this.$t('FileHistory.view')}</a>`
          }
        },
        {
          headerName: this.$t('SeaExport.descr'), field: 'REMARK', colId: 'REMARK', width: 300
        }
      ]
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onFileView', function(value) {
      context.onFileView(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    onShow() {
      this.initializeHandler()
    },
    initializeHandler() {
      const maxResult = LocalStorageUtils.getConfiguration('maxResult')
      if (maxResult && parseInt(maxResult) > 0) {
        this.filter.maxResult = maxResult
      }
      this.filter.importResultList = [
        { label: this.$t('Message.AllSuccess'), value: 1 },
        { label: this.$t('Message.AllFailed'), value: 2 },
        { label: this.$t('Message.PartialFailurePartialSuccess'), value: 3 }
      ]
      this.getBusinessTypeDataProvider(this.lob)
      this.getCbNoRuleDataProvider(this.lob)
    },
    // 初始化业务类型规则下拉框
    getBusinessTypeDataProvider(jobType) {
      const businessTypeArr = []
      if (SystemConstants.AE.code === jobType) {
        businessTypeArr.push({ label: this.$t('Payment.airExport'), value: 'AE' })
      } else if (SystemConstants.AI.code === jobType) {
        businessTypeArr.push({ label: this.$t('Payment.airImport'), value: 'AI' })
      } else if (SystemConstants.RE.code === jobType || SystemConstants.RI.code === jobType) {
        businessTypeArr.push({ label: this.$t('Partners.RailwayExport'), value: 'RE' })
        businessTypeArr.push({ label: this.$t('CargoMsg.Cargo_RailwayImport'), value: 'RI' })
      } else if (SystemConstants.SI.code === jobType) {
        businessTypeArr.push({ label: this.$t('Payment.oceanImport'), value: 'SI' })
      } else if (SystemConstants.SE.code === jobType) {
        businessTypeArr.push({ label: this.$t('Payment.oceanExport'), value: 'SE' })
      } else if (SystemConstants.IE.code === jobType) {
        businessTypeArr.push({ label: this.$t('CargoMsg.Cargo_IntegratedJob'), value: 'IE' })
      } else {
        businessTypeArr.push({ label: this.$t('Payment.oceanExport'), value: 'SE' })
        businessTypeArr.push({ label: this.$t('Payment.oceanImport'), value: 'SI' })
        businessTypeArr.push({ label: this.$t('Payment.airExport'), value: 'AE' })
        businessTypeArr.push({ label: this.$t('Payment.airImport'), value: 'AI' })
        businessTypeArr.push({ label: this.$t('Partners.RailwayExport'), value: 'RE' })
        businessTypeArr.push({ label: this.$t('CargoMsg.Cargo_RailwayImport'), value: 'RI' })
        businessTypeArr.push({ label: this.$t('CargoMsg.Cargo_IntegratedJob'), value: 'IE' })
      }
      this.filter.businessTypeList = businessTypeArr
      this.filter.businessType = businessTypeArr[0].value
    },
    // 初始化编号规则下拉框
    getCbNoRuleDataProvider(jobType) {
      const cbNoRuleArr = []
      if (SystemConstants.AE.code === jobType) {
        cbNoRuleArr.push({ label: this.$t('SeaExport.JobNo'), value: '0' })
        cbNoRuleArr.push({ label: 'MAWB NO', value: '1' })
        cbNoRuleArr.push({ label: this.$t('SeaExport.CustomerReferenceNumber'), value: '2' })
      } else if (SystemConstants.AI.code === jobType) {
        cbNoRuleArr.push({ label: this.$t('Payment.businessNumber'), value: '0' })
        cbNoRuleArr.push({ label: this.$t('Payment.mbl'), value: '1' })
        cbNoRuleArr.push({ label: this.$t('SeaExport.CustomerReferenceNumber'), value: '2' })
      } else if (SystemConstants.RE.code === jobType || SystemConstants.RI.code === jobType) {
        cbNoRuleArr.push({ label: this.$t('Payment.businessNumber'), value: '0' })
        cbNoRuleArr.push({ label: this.$t('Payment.businessReferenceNumber'), value: '1' })
      } else if (SystemConstants.SI.code === jobType) {
        cbNoRuleArr.push({ label: this.$t('Payment.businessNumber'), value: '0' })
        cbNoRuleArr.push({ label: 'MBL NO', value: '1' })
        cbNoRuleArr.push({ label: this.$t('SeaExport.CustomerReferenceNumber'), value: '2' })
      } else if (SystemConstants.IE.code === jobType) {
        cbNoRuleArr.push({ label: this.$t('Payment.businessNumber'), value: '0' })
        cbNoRuleArr.push({ label: this.$t('SeaExport.CustomerReferenceNumber'), value: '1' })
      } else {
        cbNoRuleArr.push({ label: this.$t('Payment.businessNumber'), value: '0' })
        cbNoRuleArr.push({ label: 'MBL NO', value: '1' })
        cbNoRuleArr.push({ label: this.$t('Payment.businessReferenceNumber'), value: '2' })
      }
      this.filter.noRule = cbNoRuleArr[0].value
      this.filter.noRuleList = cbNoRuleArr
    },
    // 业务类型联动编号规则
    bussinessType_changeHandler() {
      this.getCbNoRuleDataProvider(this.filter.businessType)
    },
    // 结算单位 改变
    tiAccount_changeHandler(item) {
      this.filter.tiAccount = item.value
      if (this.filter.tiAccount <= 0) return
      if (item) {
        this.filter.overSeaType = (item.designationAgent || item.overseaAgent) ? 1 : 0
      }
    },
    // 结算单位 过滤
    tiAccountFilter(item, inputVal) {
      if (!item) return false
      if (parseInt(item.branchId) !== this.$store.getters.currentOfficeId && parseInt(item.branchId) !== 1) {
        return false
      }
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.active
    },
    queryHandler() {
      const filter = {}
      if (this.filter.importResult && this.filter.importResult > 0) {
        filter['importResult'] = this.filter.importResult
      }
      if (this.filter.pushTimeStar) {
        filter['pushTimeStar'] = this.filter.pushTimeStar
      }
      if (this.filter.pushTimeEnd) {
        filter['pushTimeEnd'] = this.filter.pushTimeEnd
      }
      if (this.filter.businessType) {
        filter['businessType'] = this.filter.businessType
      }
      if (this.filter.noRule && parseInt(this.filter.noRule) > -1) {
        filter['cbNoRule'] = this.filter.noRule
      }
      if (this.filter.tiAccount > 0) {
        filter['tiAccount'] = this.filter.tiAccount
      }
      if (this.filter.overSeaType > -1) {
        filter['overSeaType'] = this.filter.overSeaType
      }
      if (this.filter.accountType > -1) {
        filter['accountType'] = this.filter.accountType
      }
      filter['max'] = this.filter.maxResult || 20
      filter['branchId'] = this.$store.getters.currentOfficeId
      // Charge.queryImportFileRecordLog(filter,maxResult.value,loadSuccessHandler, queryFaultHandler);
      this.loading = getLoading()
      queryImportFileRecordLog(filter).then(res => {
        this.rowData = res.data
        this.gridApi.clearFocusedCell()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 业务类型 businessType
    getBusinessTypeFunc(value) {
      if (!value) return ''
      const fieldName = this.isZh ? 'chineseName' : 'englishName'
      const types = value.split(';')
      return types.map(type => {
        if (type === SystemConstants.AE.code) return SystemConstants.AE[fieldName]
        if (type === SystemConstants.AI.code) return SystemConstants.AI[fieldName]
        if (type === SystemConstants.SE.code) return SystemConstants.SE[fieldName]
        if (type === SystemConstants.SI.code) return SystemConstants.SI[fieldName]
        if (type === SystemConstants.RE.code) return SystemConstants.RE[fieldName]
        if (type === SystemConstants.RI.code) return SystemConstants.RI[fieldName]
        return type
      }).join(';')
    },
    // 编号规则 noRule
    getNoRuleFunc(data, noRule) {
      const jobType = data.LOB
      let cbNoRule = ''
      const value = noRule !== undefined ? noRule.toString() : ''
      if (SystemConstants.AE.code === jobType) {
        if (value === '0') {
          cbNoRule = this.$t('CargoMsg.Cargo_JobNo')
        } else if (value === '1') {
          cbNoRule = 'MAWB NO'
        } else if (value === '2') {
          cbNoRule = this.$t('CargoMsg.Cargo_CustomerReferenceNumber')
        }
      } else if (SystemConstants.AI.code === jobType) {
        if (value === '0') {
          cbNoRule = this.$t('CargoMsg.Cargo_BusinessNo')
        } else if (value === '1') {
          cbNoRule = this.$t('CargoMsg.Cargo_MblNo')
        } else if (value === '2') {
          cbNoRule = this.$t('CargoMsg.Cargo_CustomerReferenceNumber')
        }
      } else if (SystemConstants.RE.code === jobType || SystemConstants.RI.code === jobType) {
        if (value === '0') {
          cbNoRule = this.$t('CargoMsg.Cargo_BusinessNo')
        } else if (value === '1') {
          cbNoRule = this.$t('CargoMsg.Cargo_BusinessReferenceNo')
        }
      } else if (SystemConstants.SI.code === jobType) {
        if (value === '0') {
          cbNoRule = this.$t('CargoMsg.Cargo_BusinessNo')
        } else if (value === '1') {
          cbNoRule = 'MBL NO'
        } else if (value === '2') {
          cbNoRule = this.$t('CargoMsg.Cargo_CustomerReferenceNumber')
        }
      } else if (SystemConstants.IE.code === jobType) {
        if (value === '0') {
          cbNoRule = this.$t('CargoMsg.Cargo_BusinessNo')
        } else if (value === '1') {
          cbNoRule = this.$t('CargoMsg.Cargo_CustomerReferenceNumber')
        }
      } else {
        if (value === '0') {
          cbNoRule = this.$t('CargoMsg.Cargo_BusinessNo')
        } else if (value === '1') {
          cbNoRule = 'MBL NO'
        } else if (value === '2') {
          cbNoRule = this.$t('CargoMsg.Cargo_BusinessReferenceNo')
        }
      }
      return cbNoRule
    },
    // 查看文件
    async onFileView(fileId) {
      if (!fileId) return
      await cache.load(cacheName.CONFIG)
      // const storageURL = cache.config.get('StorageURL')
      const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.sessionId}`
      window.open(url)
    },
    saveMaxResult() {
      if (this.filter.maxResult) LocalStorageUtils.setConfiguration('maxResult', this.filter.maxResult)
    }
  }
}
</script>

<style scoped>

</style>
